__turbopack_context__.v({
  "clickableIcon": "api-keys-module-scss-module__9fQ1-W__clickableIcon",
  "wrap": "api-keys-module-scss-module__9fQ1-W__wrap",
});
